import { isValidRedirectionRoute } from '../services/auth.service'
import * as types from './types'
import { InitialState } from '../models/initial-state';
import { FixedProperties } from '../models/Fixed-Properties'
export const mutations = {

  [types.B2B_TOGGLE_SIDE_NAV](state, value) {
    state.appDrawer = value;
  },
  [types.B2B_ACTIVE_ROUTE_ITEM](state, activeRouteItem) {
    state.activeRouteItem = {
      ...activeRouteItem
    };

  },
  [types.B2B_ACTIVE_SUB_ROUTE_ITEM](state, value) {
    state.activeSubRouteItem = value;
  },
  [types.B2B_SET_HAS_CREDIT_NOTE](state, value) {
    state.has_credit_note = value;
  },
  [types.B2B_SET_APP_NAV_ITEM_EXPAND](state, activeSubRouteItem) {
    state.appNavItems = state.appNavItems.map(a => {
      a.expandable = false
      if (a.route === activeSubRouteItem.route) {
        a.expandable = activeSubRouteItem.expandable
      }
    });
    state.appNavItems = [
      ...state.appNavItems
    ]
  },
  [types.B2B_SET_APP_NAV_ITEMS](state, payload) {
    state.appNavItems = payload;
  },
  [types.B2B_SET_SHOW_CLOSE_ICON](state, payload) {
    state.showCloseIcon = payload;
  },
  [types.B2B_SET_MAIN_NAB_LIST](state, payload) {
    state.appNavItems = payload.appNavItems;
  },
  [types.B2B_SET_REDIRECT_ROUTE](state, payload) {
    state.redirectRoute = payload;
  },

  [types.B2B_SET_LOGIN_USER](state, payload) {
    state.loginUser = {
      ...state.loginUser,
      ...payload
    };
  },
  [types.B2B_SET_RESET_PASSWORD](state, payload) {
    state.resetPassword = {
      ...state.resetPassword,
      ...payload
    };
  },
  [types.B2B_SET_LOGIN_REDIRECT_ROUTE](state, payload) {
    if (isValidRedirectionRoute(payload.name)) {
      state.loginRedirectRoute = payload;
    }
  },

  [types.B2B_SET_RESULT_RESET_PASSWORD](state, payload) {
    state.isResetPassword = payload
  },
  [types.B2B_SET_USER_DETAILS](state, payload) {
    state.userDetails = payload
  },
  [types.B2B_SET_USER_INFO](state, payload) {
    state.userInfo = payload
  },
  [types.B2B_SET_LANGUAGES](state, payload) {
    state.languages = payload
  },

  [types.B2B_SET_SELECTED_ROYALTY_ITEM](state, payload) {
    state.selectedRoyaltyItem = payload

  },
  [types.B2B_SET_ROYALTY_PERIOD_ID](state, payload) {
    state.royalty_period_id = payload

  },
  [types.B2B_SET_ROYALTY_YEARS](state, payload) {
    state.appNavItems = state.appNavItems.map(item => {
      if (item.title == FixedProperties.ROYALTY_ACCOUNT_TITLE) {
        item.children = payload;
      }
      return item;
    });
    state.appNavItems = [
      ...state.appNavItems
    ]

  },
  [types.B2B_SET_LOADED_DATA](state, payload) {
    state.is_Loaded_Data = payload
  },
  [types.B2B_SET_LOADED_DATA_TEXT](state, payload) {
    state.loading_Text = payload
  },
  [types.B2B_SET_USER](state, payload) {
    state.user = payload
  },
  [types.B2B_SET_IS_LOADED_HOME_PAGE_DATA](state, payload) {
    state.is_loaded_home_page_data = payload;
  },
  [types.B2B_SET_IS_LOADED_ROYALTY_PAGE_DATA](state, payload) {
    state.is_loaded_royalty_page_data = payload;
  },
  [types.B2B_SET_ROYALTIES_BY_YEAR](state, payload) {
    state.royalties = payload;
  },
  [types.B2B_SET_IS_LOGGED_IN](state, payload) {
    state.is_Logged_In = payload;
  },
  [types.B2B_SET_HOME_PAGE_CHART](state, payload) {
    state.chartReport = payload;
  },
  [types.B2B_SET_FILTERED_CHANNEL_CHART](state, payload) {
    state.chartReport.channel_report_data = payload;
  },
  [types.B2B_SET_ROYALTY_PAGE_CHART](state, payload) {
    state.royaltyChartReport = payload;
  },
  [types.B2B_SET_CHANNEL_LOADED_DATA](state, payload) {
    state.is_loaded_channel_data = payload;
  },
}
